module.exports = __webpack_public_path__ + "img/confetti_4a.0bda3d7a.svg";